module.exports = __webpack_public_path__ + "static/parade-2020-house05-1eefb0deedf76299c8a612dbc6a66733.jpg";